import React, {useContext} from 'react';

import {ErrorSink} from "./ErrorSink";
import {Questions} from "./fields/Questions";
import {ProductInfoContext} from "./data/ApplicationDataSource";

export function DriverQuestions() {

  let {productSetup} = useContext(ProductInfoContext);

  if (!productSetup.questions) {
    return <ErrorSink message='no questions for driver defined' />
  }

  return <Questions questions={productSetup.questions} />;

}